// extracted by mini-css-extract-plugin
export default {"wrap":"aI-z","subtitle":"bI-z","contentWrap":"cI-z","imgWrap":"dI-z","heading":"eI-z","copy":"fI-z"};